import { render, staticRenderFns } from "./ResidualValuesTable.vue?vue&type=template&id=0b4dd444&scoped=true"
import script from "./ResidualValuesTable.vue?vue&type=script&lang=js"
export * from "./ResidualValuesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4dd444",
  null
  
)

export default component.exports